// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "../../common/utils", "./Base"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("../../common/utils"), require("./Base"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.utils, global.Base);
    global.Input = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _utils, _Base) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Input = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  var _excluded = ["className", "type", "label", "error", "labelClassName", "errorClassName", "containerClassName"];
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
  function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
  var Input = _exports.Input = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
    var className = _ref.className,
      type = _ref.type,
      label = _ref.label,
      error = _ref.error,
      labelClassName = _ref.labelClassName,
      errorClassName = _ref.errorClassName,
      containerClassName = _ref.containerClassName,
      props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/React.createElement("div", {
      className: containerClassName
    }, label && /*#__PURE__*/React.createElement("label", {
      className: (0, _utils.cn)('cop-text-sm cop-font-bold', labelClassName)
    }, label), /*#__PURE__*/React.createElement("input", _extends({
      type: type,
      className: (0, _utils.cn)(_Base.inputClasses, error ? 'cop-border-red-600' : '', label ? 'cop-mt-1' : '', className),
      ref: ref
    }, props)), error && /*#__PURE__*/React.createElement("div", {
      className: (0, _utils.cn)('cop-text-right cop-text-sm cop-text-danger', errorClassName)
    }, error));
  });
  Input.displayName = 'Input';
});
